<template>
  <div>

    <div style="padding-left: 18px;padding-right: 18px;height: 100%;">
      <div>
        <el-row :gutter="0" class="panel-group"
          style="height: 280px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 150px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="dongliyongdian" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  动力用电
                </div>
              </div>


            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1446px;float: left;white-space: nowrap;">
            <el-table border :data="powerValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in power">
                <el-table-column :key="index2" v-if="index2 < 17" :prop="item2" :label="item2" width="85" align="center"
                  style="background-color: #ebeef5;">
                </el-table-column>
              </template>
            </el-table>
            <el-table border :data="powerValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in power">
                <el-table-column :key="index2" v-if="index2 >= 17" :prop="item2" :label="item2" width="85"
                  align="center">
                </el-table-column>
              </template>
            </el-table>
          </el-col>
        </el-row>

        <el-row :gutter="0" class="panel-group"
          style="height: 280px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 150px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="zhaomingyongdian2" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  照明用电
                </div>
              </div>


            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1446px;float: left;white-space: nowrap;">
            <el-table border :data="lightingValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in lighting">
                <el-table-column :key="index2" v-if="index2 < 17" :prop="item2" :label="item2" width="85" align="center"
                  style="background-color: #ebeef5;">
                </el-table-column>
              </template>
            </el-table>
            <el-table border :data="lightingValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in lighting">
                <el-table-column :key="index2" v-if="index2 >= 17" :prop="item2" :label="item2" width="85"
                  align="center">
                </el-table-column>
              </template>
            </el-table>
          </el-col>
        </el-row>

        <el-row :gutter="0" class="panel-group"
          style="height: 280px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 150px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="rent_icon_kongtiao" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  空调用电
                </div>
              </div>


            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1446px;float: left;white-space: nowrap;">
            <el-table border :data="electricityValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in electricity">
                <el-table-column :key="index2" v-if="index2 < 17" :prop="item2" :label="item2" width="85" align="center"
                  style="background-color: #ebeef5;">
                </el-table-column>
              </template>
            </el-table>
            <el-table border :data="electricityValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in electricity">
                <el-table-column :key="index2" v-if="index2 >= 17" :prop="item2" :label="item2" width="85"
                  align="center">
                </el-table-column>
              </template>
            </el-table>
          </el-col>
        </el-row>

        <el-row :gutter="0" class="panel-group"
          style="height: 280px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 150px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="jifangyongdian" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  机房用电
                </div>
              </div>


            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1446px;float: left;white-space: nowrap;">
            <el-table border :data="roomValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in room">
                <el-table-column :key="index2" v-if="index2 < 17" :prop="item2" :label="item2" width="85" align="center"
                  style="background-color: #ebeef5;">
                </el-table-column>
              </template>
            </el-table>
            <el-table border :data="roomValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in room">
                <el-table-column :key="index2" v-if="index2 >= 17" :prop="item2" :label="item2" width="85"
                  align="center">
                </el-table-column>
              </template>
            </el-table>
          </el-col>
        </el-row>

        <el-row :gutter="0" class="panel-group"
          style="height: 280px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 150px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="dianguolu" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  电锅炉用电
                </div>
              </div>



            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1446px;float: left;white-space: nowrap;">
            <el-table border :data="boilersValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in boilers">
                <el-table-column :key="index2" v-if="index2 < 17" :prop="item2" :label="item2" width="85" align="center"
                  style="background-color: #ebeef5;">
                </el-table-column>
              </template>
            </el-table>
            <el-table border :data="boilersValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in boilers">
                <el-table-column :key="index2" v-if="index2 >= 17" :prop="item2" :label="item2" width="85"
                  align="center">
                </el-table-column>
              </template>
            </el-table>
          </el-col>
        </el-row>

        <el-row :gutter="0" class="panel-group"
          style="height: 280px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 150px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="qitayongdian" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  其他用电
                </div>
              </div>


            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1446px;float: left;white-space: nowrap;">
            <el-table border :data="otherValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in other">
                <el-table-column :key="index2" v-if="index2 < 17" :prop="item2" :label="item2" width="85" align="center"
                  style="background-color: #ebeef5;">
                </el-table-column>
              </template>
            </el-table>
            <el-table border :data="otherValue" style="font-size: 11px;">
              <template v-for="(item2, index2) in other">
                <el-table-column :key="index2" v-if="index2 >= 17" :prop="item2" :label="item2" width="85"
                  align="center">
                </el-table-column>
              </template>
            </el-table>
          </el-col>
        </el-row>

      </div>
    </div>
  </div>
</template>

<script>
  // import layout1 from "../../layout/layout1";
  // import ECharts from "vue-echarts";
  export default {
    name: "bianyaqi",
    data () {
      return {
        projectId: 0,
        datas: {},
        power: [],
        powerValue: [],
        lighting: [],
        lightingValue: [],
        electricity: [],
        electricityValue: [],
        room: [],
        roomValue: [],
        boilers: [],
        boilersValue: [],
        other: [],
        otherValue: []
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      },
    },
    components: {
      // layout1, 
      // "v-chart": ECharts,
    },
    created () {
      this.projectId = this.$getCookie("projectId");

      this.searchPeak();
    },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      searchPeak () {
        this.todayEleLoading = true;
        let strs = this.date.split("-")
        let str = strs[0] + "-" + strs[1]
        this.$http
          .post("bma-distribution-service/monthReport/searchLoadCategory", {
            date: str,
            projectId: this.projectId,
            dateType: this.dateType
          })
          .then((res) => {
            this.datas = res.data


            {
              let tempArray = {}
              this.datas.power.forEach((data) => {
                this.power.push(data.day);
                // this.tableData[0]
                tempArray[data.day] = data.value

              })
              this.powerValue.push(tempArray)
            }
            {
              let tempArray = {}
              this.datas.lighting.forEach((data) => {
                this.lighting.push(data.day);
                // this.tableData[0]
                tempArray[data.day] = data.value

              })
              this.lightingValue.push(tempArray)
            }
            {
              let tempArray = {}
              this.datas.electricity.forEach((data) => {
                this.electricity.push(data.day);
                // this.tableData[0]
                tempArray[data.day] = data.value

              })
              this.electricityValue.push(tempArray)
            }
            {
              let tempArray = {}
              this.datas.room.forEach((data) => {
                this.room.push(data.day);
                // this.tableData[0]
                tempArray[data.day] = data.value

              })
              this.roomValue.push(tempArray)
            }
            {
              let tempArray = {}
              this.datas.boilers.forEach((data) => {
                this.boilers.push(data.day);
                // this.tableData[0]
                tempArray[data.day] = data.value

              })
              this.boilersValue.push(tempArray)
            }
            {
              let tempArray = {}
              this.datas.other.forEach((data) => {
                this.other.push(data.day);
                // this.tableData[0]
                tempArray[data.day] = data.value

              })
              this.otherValue.push(tempArray)
            }


          });
      },

    },
  };
</script>

<style lang="scss" scoped>
  .panel-group {
    margin-top: 18px;
    background: #fff;

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .card-panel-col {

      /* margin-bottom: 32px; */
      ~.el-table .cell {
        padding-left: 0px;
      }
    }

    .card-panel-col>.cell {

      padding-left: 0px;

    }

    .card-panel {
      height: 208px;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      border-color: rgba(0, 0, 0, .05);



      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shopping {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 54px 0 0 14px;
        width: 100px;
        text-align: center;
        /* padding: 16px; */
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        /* float: left; */
        font-size: 48px;
      }

      .card-panel-description {
        float: left;
        font-weight: bold;
        margin-top: 56px;
        margin-left: 10px;
        text-align: left;
        width: 200px;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-text-info {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }
</style>